import * as React from 'react';
import { Modal, Button } from "react-bootstrap";
import '../css/ModernPopups.css';

interface State { 
}

interface Props {
    title : string,
    content : string,
    show: boolean,
    hide(p:boolean) : void, //hide is a function that return true or false
}

class ConfirmPopup extends React.Component<Props, State>{
    // constructor(props: any) {
    //     super(props)
    // }

    render() {
        return (
            <Modal 
                show={this.props.show} 
                onHide={() => this.props.hide(false)}
                className="modern-modal confirm-popup"
                centered
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <i className="fas fa-exclamation-triangle"></i>
                        {this.props.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="confirm-icon">
                        <i className="fas fa-question-circle"></i>
                    </div>
                    <div className="confirm-message">
                        {this.props.content}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={()=>this.props.hide(false)}>
                        <i className="fas fa-times me-2"></i>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={() =>this.props.hide(true)} >
                        <i className="fas fa-check me-2"></i>
                        Confirm
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default ConfirmPopup;